const SIZAMINA_ROUTE_CONSTANTS = {
  ROOT: '/',
  ALL: '*',
  SIGNIN: 'signIn',
  COOKIEPOLICY: 'cookie-policy',
  TERMSANDCONDITIONS: 'terms-and-conditions',
  FREQUENTLYASKEDQUESTIONS: 'frequently-asked-questions',
  OUTLETS: 'outlets',
  CASHUPITEM: 'cashUpReport',
  STOCKINHAND: 'stockReport',
  STOCKTAKE: 'stockTake',
  STOCKADD: 'addStock',
  USERMANAGEMENT: 'userManagement'
};
export default SIZAMINA_ROUTE_CONSTANTS;
